import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SkillCategory from './SkillCategory';
import './Skills.css';

const Skills = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: window.innerWidth <= 768 ? 0.05 : 0.2,
        rootMargin: '30px'
      }
    );

    const section = document.getElementById('skills');
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  const skillCategories = [
    {
      title: t('skills.categories.vfx.title'),
      subtitle: t('skills.categories.vfx.subtitle'),
      icon: '',
      color: 'cyan',
      tools: [
        {
          name: t('skills.categories.vfx.tools.unreal.name'),
          description: t('skills.categories.vfx.tools.unreal.description')
        },
        {
          name: t('skills.categories.vfx.tools.niagara.name'),
          description: t('skills.categories.vfx.tools.niagara.description')
        },
        {
          name: t('skills.categories.vfx.tools.adobe.name'),
          description: t('skills.categories.vfx.tools.adobe.description')
        },
        {
          name: t('skills.categories.vfx.tools.blender.name'),
          description: t('skills.categories.vfx.tools.blender.description')
        },
        {
          name: t('skills.categories.vfx.tools.substance.name'),
          description: t('skills.categories.vfx.tools.substance.description')
        },
        {
          name: t('skills.categories.vfx.tools.embergen.name'),
          description: t('skills.categories.vfx.tools.embergen.description')
        }
      ]
    },
    {
      title: t('skills.categories.web.title'),
      subtitle: t('skills.categories.web.subtitle'),
      icon: '',
      color: 'magenta',
      tools: [
        {
          name: t('skills.categories.web.tools.html.name'),
          description: t('skills.categories.web.tools.html.description')
        },
        {
          name: t('skills.categories.web.tools.react.name'),
          description: t('skills.categories.web.tools.react.description')
        },
        {
          name: t('skills.categories.web.tools.cms.name'),
          description: t('skills.categories.web.tools.cms.description')
        },
        {
          name: t('skills.categories.web.tools.php.name'),
          description: t('skills.categories.web.tools.php.description')
        },
        {
          name: t('skills.categories.web.tools.office.name'),
          description: t('skills.categories.web.tools.office.description')
        }
      ]
    },
    {
      title: t('skills.categories.ai.title'),
      subtitle: t('skills.categories.ai.subtitle'),
      icon: '',
      color: 'cyan',
      tools: [
        {
          name: t('skills.categories.ai.tools.midjourney.name'),
          description: t('skills.categories.ai.tools.midjourney.description')
        },
        {
          name: t('skills.categories.ai.tools.stable.name'),
          description: t('skills.categories.ai.tools.stable.description')
        },
        {
          name: t('skills.categories.ai.tools.chatgpt.name'),
          description: t('skills.categories.ai.tools.chatgpt.description')
        },
        {
          name: t('skills.categories.ai.tools.elevenlabs.name'),
          description: t('skills.categories.ai.tools.elevenlabs.description')
        },
        {
          name: t('skills.categories.ai.tools.suno.name'),
          description: t('skills.categories.ai.tools.suno.description')
        },
        {
          name: t('skills.categories.ai.tools.sora.name'),
          description: t('skills.categories.ai.tools.sora.description')
        }
      ]
    }
  ];

  return (
    <section id="skills" className="skills section">
      <div className="container">
        <div className={`skills-content ${isVisible ? 'visible' : ''}`}>
          <h2 className="skills-title fade-in-up">
            {t('skills.title')}
          </h2>
          <p className="skills-subtitle fade-in-up">
            {t('skills.subtitle')}
          </p>

          <div className="skills-grid-container">
            <div className="skills-grid">
              {skillCategories.map((category, index) => (
                <SkillCategory
                  key={index}
                  {...category}
                  delay={index * 0.3}
                  isVisible={isVisible}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;